import React from 'react'
import { Card, Text } from 'theme-ui'
import Section from '@components/Section'
import Navigation from '@components/Navigation'
import { useSiteConfig, mapSocialIcons } from '@helpers'

const Social = () => {
  const { social } = useSiteConfig()

  return (
    <Section aside title="Let's Talk">
      <Card variant='paper'>
        <Text variant='p'>
         Follow Us for new updates.
         <br />
         <iframe  title="facebook" src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&width=100&layout=standard&action=like&size=large&share=true&height=35&appId=628743398075467" style={{width:"100%", height:"45px", border: "none", "overflow":"hidden", "scrolling":"no" ,marginTop:"10px",frameborder: 0 ,"allowTransparency":"true", "allow":"encrypted-media"}}></iframe>
        {/* <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&width=100&layout=box_count&action=like&size=large&share=true&height=65&appId=628743398075467" ></iframe> */}
        </Text>
        <Navigation items={mapSocialIcons(social)} iconOnly />
      </Card>
    </Section>
  )
}

export default Social
